angular.module('SpidApp')

.factory('StockFlowService',
		['StockFlow', 'Restangular',
function (StockFlow,   Restangular) {
	var StockFlowService = {
		
		// GET: /agencies/{agency_id}/stocks/{stock_id}/stockflows
		findByAgencyIdAndStockId: function (agencyId, stockId) {
			if (!agencyId || !stockId) {
				throw 'StockFlowService::all() - Missing parameters'
			}
			return Restangular.one('agencies', agencyId).one('stocks', stockId).all('stockflows').getList().then(function (datas) {
				return _.map(datas, function (data) {
					return new StockFlow(data)
				})
			})
		},
		
		allByAgencyIdAndStockIdAndMonth: function (agencyId, stockId, isoDate) {
			if (!agencyId || !stockId || !isoDate) {
				throw 'StockFlowService::allByAgencyIdAndStockIdAndMonth() - Missing parameters'
			}
			
			var targetDate = new Date(isoDate).toISOString().substr(0, 7)
			return Restangular.one('agencies', agencyId).one('stocks', stockId).all('stockflows').one('yyyymm', targetDate).getList().then(function (datas) {
				return _.map(datas, function (data) {
					return new StockFlow(data)
				})
			})
		},
		
		allByAgencyIdAndStockIdAndYear: function (agencyId, stockId, isoDate) {
			if (!agencyId || !stockId || !isoDate) {
				throw 'StockFlowService::allByAgencyIdAndStockIdAndYear() - Missing parameters'
			}
			
			var targetDate = new Date(isoDate).toISOString().substr(0, 4)
			return Restangular.one('agencies', agencyId).one('stocks', stockId).all('stockflows').one('yyyymm', targetDate).getList().then(function (datas) {
				return _.map(datas, function (data) {
					return new StockFlow(data)
				})
			})
		},
		
		// GET: /agencies/{agency_id}/stocks/stockflows/yyyymm/{yyyymm}
		allByAgencyIdAndMonth: function (agencyId, isoDate) {
			if (!agencyId || !isoDate) {
				throw 'StockFlowService::allByAgencyIdAndMonth() - Missing parameters'
			}
			
			var targetDate = new Date(isoDate).toISOString().substr(0, 7)
			return Restangular.one('agencies', agencyId).all('stocks').all('stockflows').one('yyyymm', targetDate).getList().then(function (datas) {
				return _.map(datas, function (data) {
					return new StockFlow(data)
				})
			})
		},
		
		// GET: /agencies/{agency_id}/stocks/stockflows/yyyy/{yyyy}
		allByAgencyIdAndYear: function (agencyId, isoDate) {
			if (!agencyId || !isoDate) {
				throw 'StockFlowService::allByAgencyIdAndYear() - Missing parameters'
			}
			
			var targetDate = new Date(isoDate).toISOString().substr(0, 4)
			return Restangular.one('agencies', agencyId).all('stocks').all('stockflows').one('yyyy', targetDate).getList().then(function (datas) {
				return _.map(datas, function (data) {
					return new StockFlow(data)
				})
			})
		},
		
		// POST: /agencies/{agency_id}/stocks/{stock_id}/stockflows
		save: function(stockFlow, agencyId, stockId) {
			if (!stockFlow || !agencyId || !stockId) {
				throw 'StockFlowService::save() - Missing parameters'
			}
			return Restangular.one('agencies', agencyId).one('stocks', stockId).all('stockflows').post(stockFlow);
		},
		
		// POST: /agencies/{agency_id}/stocks/stockflows
		bulkSave: function(stockFlows, agencyId) {
			if (!stockFlows || !agencyId) {
				throw 'StockFlowService::saveBulk() - Missing parameters'
			}
			return Restangular.one('agencies', agencyId).all('stocks').all('stockflows').post(stockFlows);
		}
	}

	return StockFlowService
}])
